import type {WalletToken} from './types';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Map a raw digital-wallet-token record (from Equals' list endpoint) to our
 * `WalletToken` shape. Field names are tolerated in a few forms because the API
 * preview and the real data have differed (e.g. `token` vs `tokenId`); confirm
 * the exact keys with Equals and trim the fallbacks once known.
 */
export function normalizeWalletToken(raw: any): WalletToken {
  return {
    tokenId: String(raw?.tokenId ?? raw?.token ?? raw?.id ?? ''),
    cardId: String(raw?.cardId ?? raw?.card_id ?? ''),
    walletType:
      raw?.walletType ??
      raw?.wallet_type ??
      raw?.walletProvider ??
      raw?.wallet_provider ??
      '',
    deviceType: raw?.deviceType ?? raw?.device_type ?? '',
    deviceId: raw?.deviceId ?? raw?.device_id ?? undefined,
    cardName: raw?.cardName ?? raw?.card_name ?? undefined,
    lastFour:
      raw?.lastFour ?? raw?.last_four ?? raw?.card_number_last4 ?? undefined,
    state: raw?.state ?? raw?.status ?? undefined,
    createdAt:
      raw?.createdAt ??
      raw?.created_at ??
      raw?.creationDate ??
      raw?.created_time ??
      undefined,
  };
}

/**
 * Extract + normalize the token array from the list response, tolerating the
 * shapes the backend may return: `{result:{rows}}`, `{result:[…]}`, `{rows}`,
 * or a bare array.
 */
export function extractWalletTokens(res: any): WalletToken[] {
  const payload = res?.result ?? res;
  const rows = Array.isArray(payload) ? payload : (payload?.rows ?? []);
  return (Array.isArray(rows) ? rows : []).map(normalizeWalletToken);
}
